module.exports = __webpack_public_path__ + "88588190828e5888d1b92b4e388e53d2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-16.png
// module id = 3243
// module chunks = 0